import { defineComponent as _defineComponent } from 'vue'
import {useSessionStore, useWalletStore} from "@/pinia";
import router from "@/router";
import {onBeforeMount, ref, watchEffect} from "vue";
import TokenShow from "@/views/token/TokenShow.vue";

// store

export default /*#__PURE__*/_defineComponent({
  __name: 'TokenShowContainer',
  setup(__props) {

const walletStore = useWalletStore();
const sessionStore = useSessionStore();

// data
const mint = ref<string>(router.currentRoute.params.id);

onBeforeMount(() =>{
	if (mint.value == "login" || mint.value == "/auth/login") {
		const token = sessionStore.getLastToken
		router.push(`/${token}`)
	}
})

// watch
watchEffect(() => {
	sessionStore.setLastToken(mint.value);
});

return { __sfc: true,walletStore, sessionStore, mint, TokenShow }
}

})